<template>
  <a-layout-content class="d-flex flex-column justify-around">
    <a-empty></a-empty>
  </a-layout-content>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style>
</style>